import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { NewOrderPage } from '@/features/orders/NewOrderPage';

/*
  New order (ALS-62). Its own route, before $orderId in the generated tree so "new" is never read
  as an id. `?customer=` is the client record's New order: the form opens with that client chosen.
  `?from=` is a cancelled order's Re-raise (ALS-260): the form opens filled from it, and the order
  it creates links back. A junk value is ignored rather than throwing the route.
*/
const newOrderSearch = z.object({
    customer: z.coerce.number().int().positive().optional().catch(undefined),
    from: z.coerce.number().int().positive().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/orders/new')({
    validateSearch: (search) => newOrderSearch.parse(search),
    component: NewOrderRoute,
});

function NewOrderRoute() {
    const { customer, from } = Route.useSearch();
    return <NewOrderPage customerId={customer} reraiseFrom={from} />;
}
